module.exports = __webpack_public_path__ + "img/Buss_57_nyast.63597a70.jpg";